export const EXPERIMENT_FIELD_DATA = 'EXPERIMENT_FIELD_DATA';
export const UPDATE_EXPERIMENT_FIELD_DATA = 'UPDATE_EXPERIMENT_FIELD_DATA';
